import { useRef, useState } from 'react';

export default function CaseStudies() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    if (!scrollRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const cases = [
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20vacation%20rental%20property%20in%20Japanese%20mountain%20resort%20area%2C%20minimalist%20architecture%20with%20natural%20wood%20elements%2C%20clean%20simple%20background%2C%20professional%20real%20estate%20photography%2C%20bright%20daylight%2C%20high-end%20property%20showcase%2C%20serene%20mountain%20view%2C%20contemporary%20Japanese%20design%20aesthetic&width=600&height=600&seq=case-study-mountain-resort-001&orientation=squarish',
      company: '軽井沢リゾート開発株式会社',
      description: '高級別荘地における複数物件の一括管理と収益最適化を実現'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Elegant%20beachfront%20vacation%20rental%20property%20in%20Okinawa%20Japan%2C%20modern%20tropical%20architecture%2C%20simple%20clean%20background%2C%20professional%20photography%2C%20bright%20natural%20lighting%2C%20luxury%20resort%20atmosphere%2C%20ocean%20view%20property%2C%20minimalist%20Japanese%20coastal%20design&width=600&height=600&seq=case-study-okinawa-beach-002&orientation=squarish',
      company: '沖縄観光開発グループ',
      description: 'ビーチフロント物件の稼働率を年間平均85%まで向上'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Premium%20urban%20vacation%20rental%20apartment%20in%20Tokyo%20city%20center%2C%20sophisticated%20modern%20interior%2C%20clean%20simple%20background%2C%20professional%20real%20estate%20photography%2C%20bright%20ambient%20lighting%2C%20high-end%20city%20property%2C%20contemporary%20Japanese%20urban%20design%2C%20minimalist%20aesthetic&width=600&height=600&seq=case-study-tokyo-urban-003&orientation=squarish',
      company: '都心不動産投資株式会社',
      description: '都心マンションのバケーションレンタル転用による収益改善'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20ryokan%20style%20vacation%20rental%20property%2C%20authentic%20architecture%20with%20modern%20amenities%2C%20simple%20clean%20background%2C%20professional%20photography%2C%20natural%20lighting%2C%20cultural%20heritage%20property%2C%20refined%20Japanese%20traditional%20design%2C%20minimalist%20presentation&width=600&height=600&seq=case-study-kyoto-ryokan-004&orientation=squarish',
      company: '京都文化財保存協会',
      description: '歴史的建造物の保存と活用を両立した運用モデルの構築'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Ski%20resort%20vacation%20rental%20chalet%20in%20Hokkaido%20Japan%2C%20alpine%20architecture%20with%20snow%20setting%2C%20clean%20simple%20background%2C%20professional%20winter%20property%20photography%2C%20bright%20natural%20light%2C%20luxury%20mountain%20resort%2C%20contemporary%20Japanese%20ski%20lodge%20design%2C%20minimalist%20style&width=600&height=600&seq=case-study-hokkaido-ski-005&orientation=squarish',
      company: 'ニセコリゾート運営株式会社',
      description: 'スキーリゾートにおける国際的なゲスト対応体制の確立'
    }
  ];

  return (
    <section id="cases" className="bg-white py-36">
      <div className="max-w-[1400px] mx-auto px-8">
        <h2 className="font-serif text-[42px] text-black text-center mb-20">導入事例</h2>
        
        <div className="relative">
          <div
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide cursor-grab active:cursor-grabbing select-none"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
          >
            {cases.map((caseItem, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-[340px] bg-white border border-[#E5E5E5] rounded-lg overflow-hidden hover:shadow-[0_2px_8px_rgba(0,0,0,0.06)] transition-shadow duration-200 pointer-events-none"
              >
                <div className="w-full h-[340px] overflow-hidden">
                  <img
                    src={caseItem.image}
                    alt={caseItem.company}
                    className="w-full h-full object-cover grayscale-[30%]"
                  />
                </div>
                <div className="p-8">
                  <h3 className="text-[18px] font-bold text-black mb-4">{caseItem.company}</h3>
                  <p className="text-[14px] text-[#666666] leading-[1.7]">{caseItem.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
